import React from 'react';
import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import breakpoint from 'styled-components-breakpoint';

import { PullRight } from 'components/Shared/Scaffolding';
import { GLYPHS } from 'components/Shared/Icon';
import { MapToolbarControl, MapToolbarDropdown, MapToolbarSlider } from 'components/Map/MapToolbar';
import { SCAFFOLDING, TRANSITION, SIDECONTROLS } from 'theme';

const StyledMapToolbar = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 50px;
    padding-left: ${SCAFFOLDING.GUTTER_FACTOR(0.25)};
    padding-right: ${SCAFFOLDING.GUTTER_FACTOR(0.25)};
    z-index: ${SCAFFOLDING.Z_INDEX.indexOf('MapToolbar')};
    background-color: ${SCAFFOLDING.BG};
    box-shadow: ${SCAFFOLDING.BOX_SHADOW.BASE};
    visibility: hidden;
    transform: translate(0, -100%);
    transition: all ${TRANSITION.LENGTH_LONG} ${TRANSITION.BEZIER};

    ${ifProp(
        'active',
        css`
            visibility: visible;
            transform: translate(0, 0);
        `
    )};

    ${breakpoint('md')`
        left: ${SIDECONTROLS.BUTTON.WIDTH};
    `}

    .dropdown {
        display: inline-block;
        vertical-align: middle;
    }
`;

const MapToolbar = ({
    guides,
    onToggleGuides,
    previewZoom,
    onChangePreviewZoom,
    onSnapToCenter,
    onFitToScreen,
    ...props
}) => {
    return (
        <StyledMapToolbar {...props}>
            <PullRight>
                <MapToolbarControl
                    title="Restore the map preview to your settings"
                    glyph={GLYPHS.RESTORE_MAP}
                    onClick={onSnapToCenter}
                />
                <MapToolbarControl
                    title="Zoom preview out"
                    glyph={GLYPHS.ZOOM_OUT}
                    data-zoom="-0.1"
                    onClick={() => onChangePreviewZoom(previewZoom - 0.1)}
                />
                <MapToolbarSlider previewZoom={previewZoom} onChange={onChangePreviewZoom} />
                <MapToolbarControl
                    title="Zoom preview in"
                    glyph={GLYPHS.ZOOM_IN}
                    data-zoom="0.1"
                    onClick={() => onChangePreviewZoom(previewZoom + 0.1)}
                />
                <MapToolbarDropdown
                    previewZoom={previewZoom}
                    onFitToScreen={onFitToScreen}
                    onChangePreviewZoom={onChangePreviewZoom}
                />
            </PullRight>
        </StyledMapToolbar>
    );
};

export default MapToolbar;
